<template>
  <div>
    <router-view></router-view>
    <Affiliate-Modal/> <Payout-Modal/> <Lead-Modal/>
  </div>
</template>

<script>
  import utils from './utils'
  window.$ = require('jquery')
  export default {
    mounted () {
      this.$notify(
        {
          //component: NotificationSample,
          message: this.message,
          timeout: 7000,
          icon: 'fas fa-info-square'
        })
        
      // Fix for the readonly issue with the el-selects in cards
      $(document).on("mouseenter", '.el-select.removeReadonly input[readonly=readonly]', function() {
        $(this).attr('readonly', false)
      })
    },
    computed: {
      message () {
        let message = 'Welcome to Incentify!'
        // we notify new release notes, except in prod
        if (!process || (process.env && process.env.VUE_APP_ENV_TYPE != 'production')) {
          let lastNoteDate = ''
          const today = utils.dateToString(new Date())
          let limit = new Date()
          limit.setDate(limit.getDate()-4)
          limit = utils.dateToString(limit)
          console.log('limit = ', limit)
          if (process.env && process.env.VUE_APP_RELEASE_NOTES) {
            const lastNote = process.env.VUE_APP_RELEASE_NOTES.split('<br><br>')[0]
            const match = /^([0-9]{4}-[0-9]{1,2}-[0-9]{1,2}).*/g.exec(lastNote)
            console.log('lastNote = ', lastNote)
            console.log('match = ', match)
            if (match) {
              lastNoteDate = match[1]
            }
          }
          if (lastNoteDate > limit) {
            message += `<br><br>Check out new release notes from ${lastNoteDate} at the bottom left corner!`
          }
        }
        return message
      }
    }
  }
</script>

<style>
.archivedTableRow {
  color: #cdd0d2
}
</style>